import { useState } from "react";
import { collectionItems, collectionFilter } from "@/mocks/home";

export default function Collection() {
  const [active, setActive] = useState("全部");
  const list =
    active === "全部" ? collectionItems : collectionItems.filter((c) => c.section === active);

  return (
    <section id="collection" className="border-t border-background-200 bg-background-50 py-10 md:py-14">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 md:px-6">
        {/* 分区头 */}
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-archive-2-line text-lg" />
              </span>
              <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">黑料合集</h3>
            </div>
            <p className="mt-2 text-sm text-foreground-500">
              按主体与题材归档的合集，一张封面一件事，点进去看完整上下文与出处。
            </p>
          </div>

          <div className="flex w-fit flex-wrap items-center gap-1 rounded-full bg-secondary-100 p-1">
            {collectionFilter.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => setActive(s)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                  active === s ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        {/* 合集卡片阵 */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((c) => (
            <article key={c.id} className="group overflow-hidden rounded-lg bg-background-100">
              <div className="relative overflow-hidden">
                <img
                  src={c.cover}
                  alt={`98黑料 合集：${c.title}`}
                  title={`98黑料 ${c.section} 合集 ${c.title}`}
                  className="aspect-[4/3] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-background-50/90 px-2.5 py-1 text-xs text-foreground-800 backdrop-blur">
                  <i className="ri-archive-line text-primary-500" />
                  {c.section}
                </span>
                <span className="absolute bottom-3 left-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-100">
                  <i className="ri-fire-fill text-accent-500" />
                  热度 {c.heat}
                </span>
              </div>
              <div className="flex flex-col p-4">
                <div className="flex items-start justify-between gap-3">
                  <h4 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {c.title}
                  </h4>
                  <i className="ri-add-line mt-1 shrink-0 text-xl text-foreground-400 transition-colors group-hover:text-primary-500" />
                </div>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{c.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  {c.tags.map((t) => (
                    <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                      #{t}
                    </span>
                  ))}
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {c.updated}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {c.comments}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}